import Api from './api.service'

export default {
  createFAQ (object) {
    return Api().post('faq/create', object)
  },
  updateFAQ (object) {
    return Api().put('faq/edit/' + object.id, object.object)
  },
  faqList (filter) {
    return Api().get('faq/get', { params: filter })
  },
  getFAQ (id) {
    return Api().get('faq/get/' + id)
  }
}